import React from 'react';
import { Link } from 'react-router-dom';
import Fbsvg from '../../../assets/images/svg/header/Fb.svg'
import Twitersvg from '../../../assets/images/svg/header/Twiter.svg'
import Instasvg from '../../../assets/images/svg/header/Insta.svg'
import Pintrestsvg from '../../../assets/images/svg/header/Pintrest.svg'
import team1 from '../../../assets/images/team/team-1.png'
import team2 from '../../../assets/images/team/team-2.png'
import team3 from '../../../assets/images/team/team-3.png'
import team4 from '../../../assets/images/team/team-4.png'
import team5 from '../../../assets/images/team/team-5.png'


const teamMembers = [
    {
        id: 1,
        name: 'Alex Jason',
        position: 'Finance consultant',
        image: team1,
        socialLinks: {
            facebook: 'https://www.facebook.com/',
            twitter: 'https://x.com/',
            instagram: 'https://www.instagram.com/',
            pinterest: 'https://www.pinterest.com/',
        },
        delay: '0ms',
    },
    {
        id: 2,
        name: 'Martin Doe',
        position: 'Sale Director',
        image: team4,
        socialLinks: {
            facebook: 'https://www.facebook.com/',
            twitter: 'https://x.com/',
            instagram: 'https://www.instagram.com/',
            pinterest: 'https://www.pinterest.com/',
        },
        delay: '400ms',
    },
    {
        id: 3,
        name: 'Richard Divas',
        position: 'Business Advisor',
        image: team3,
        socialLinks: {
            facebook: 'https://www.facebook.com/',
            twitter: 'https://x.com/',
            instagram: 'https://www.instagram.com/',
            pinterest: 'https://www.pinterest.com/',
        },
        delay: '600ms',
    },
    {
        id: 4,
        name: 'Monalis',
        position: 'Manager',
        image: team5,
        socialLinks: {
            facebook: 'https://www.facebook.com/',
            twitter: 'https://x.com/',
            instagram: 'https://www.instagram.com/',
            pinterest: 'https://www.pinterest.com/',
        },
        delay: '800ms',
    },
    {
        id: 5,
        name: 'Sarah Hanley',
        position: 'Product Manager',
        image: team2,
        socialLinks: {
            facebook: 'https://www.facebook.com/',
            twitter: 'https://x.com/',
            instagram: 'https://www.instagram.com/',
            pinterest: 'https://www.pinterest.com/',
        },
        delay: '1000ms',
    },
];

const Team = () => {
    return (
        <>
            <div className="team-section-one">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 m-auto">
                            <div className="heading-box text-center">
                                <span className="sub-title animate fadeInUp wow" data-wow-duration="1500ms">
                                    Team
                                </span>
                                <h2 className="heading-title animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay="200ms">
                                    Our Team of Dedicated Digital Professionals
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center gutter-y-60">
                        {teamMembers.map((member) => (
                            <div className="col-lg-4 col-md-6" key={member.id}>
                                <div className="team-box-one animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay={member.delay}>
                                    <div className="team-image-one">
                                        <Link to="/Team">
                                            <img src={member.image} alt="team-image" />
                                        </Link>
                                    </div>
                                    <div className="team-details-one">
                                        <h4>
                                            <Link to="/Team">{member.name}</Link>
                                        </h4>
                                        <p>{member.position}</p>
                                    </div>
                                    <ul className="team-social-media-one">
                                        <li>
                                            <Link to={member.socialLinks.facebook}>
                                                <img src={Fbsvg} alt="icon" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to={member.socialLinks.twitter}>
                                                <img src={Twitersvg} alt="icon" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to={member.socialLinks.instagram}>
                                                <img src={Instasvg} alt="icon" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to={member.socialLinks.pinterest}>
                                                <img src={Pintrestsvg} alt="icon" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Team;